import axiosInstance from 'utils/axiosInstance';
import { GridResponse } from '../types/type';
import {
  AffectedUsers,
  Categorie,
  CategoryStatus,
  CredentialsChangeOrder,
  StateStatueType,
  TaskCategory,
} from '../types/categroyTask';

export const GetCategory = async (CurrentPage: number, lenght: number) => {
  const { data } = await axiosInstance.get<
    ApiResponse<GridResponse<TaskCategory[]>>
  >(`/api/categorie/GetCategory/${CurrentPage}/${lenght}`);
  return data.data;
};

export const CreateUpdate = async (credentials: {
  title: string;
  admins: string[];
}) => {
  const { data } = await axiosInstance.post<ApiResponse<null>>(
    '/api/categorie/update',
    credentials,
  );
  return data;
};

export const GetStatusListByCategory = async (id: number) => {
  const { data } = await axiosInstance.get<ApiResponse<CategoryStatus[]>>(
    `/api/categorie/GetStatusListByCategory/${id}`,
  );
  return data.data;
};

export const EditStatue = async (credentials: CategoryStatus) => {
  const { data } = await axiosInstance.post<ApiResponse<{ id: number }>>(
    '/api/categorie/EditStatue',
    credentials,
  );
  return data;
};

export const DeleteStatueTask = async (id: number) => {
  const { data } = await axiosInstance.delete<ApiResponse<null>>(
    `/api/categorie/DeleteStatueTask/${id}`,
  );
  return data;
};

export const ChangeStepStatutService = async (
  credentials: CredentialsChangeOrder,
) => {
  const { data } = await axiosInstance.post<ApiResponse<null>>(
    '/api/categorie/ChangeStepStatut',
    credentials,
  );
  return data;
};

export const ChangeOrderStatutService = async (
  credentials: CredentialsChangeOrder,
) => {
  const { data } = await axiosInstance.post<ApiResponse<null>>(
    '/api/categorie/ChangeOrderStatut',
    credentials,
  );
  return data;
};

export const GetStatueTaskById = async (id: number) => {
  const { data } = await axiosInstance.get<ApiResponse<Categorie>>(
    `/api/categorie/GetByID/${id}`,
  );
  return data.data;
};

export const UpdateStatusCategory = async (credentials: Categorie) => {
  const { data } = await axiosInstance.post<ApiResponse<null>>(
    '/api/categorie/update',
    credentials,
  );
  return data;
};

export const deleteAdmin = async (credentials: {
  categoryId: number;
  userId: string;
}) => {
  const { data } = await axiosInstance.post<ApiResponse<null>>(
    '/api/categorie/deleteAdmin',
    credentials,
  );
  return data;
};

export const getCountTaskByStatus = async (id: number) => {
  const { data } = await axiosInstance.get<ApiResponse<null>>(
    `/api/task/CountByStatus/${id}`,
  );
  return data;
};

export const getCountTaskByStatusType = async (title: number) => {
  const { data } = await axiosInstance.get<number>(
    `/api/task/CountTaskByStatusType/${title}`,
  );
  return data;
};

export const GetNonDeletedStatues = async (id: number, categoryId: number) => {
  const { data } = await axiosInstance.post<ApiResponse<SelectItem[]>>(
    '/api/task/GetNonDeletedStatues',
    {
      id: id,
      categorieId: categoryId,
    },
  );
  return data.data;
};

export const GetStateStatueById = async (id: number) => {
  const { data } = await axiosInstance.get<ApiResponse<StateStatueType>>(
    `api/categorie/GetStateStatueById/${id}`,
  );
  return data.data;
};

export const updateTasksStatue = async (credentials: StateStatueType) => {
  const { data } = await axiosInstance.post<ApiResponse<null>>(
    '/api/categorie/updateTasksStatue',
    credentials,
  );
  return data;
};

export const DeleteCategorieTask = async (id: number) => {
  const { data } = await axiosInstance.delete<ApiResponse<null>>(
    `/api/categorie/DeleteCategorieTask/${id}`,
  );
  return data;
};

export const tasksStatueaddadmin = async (credentials: {
  categoryId: number;
  userId: string;
}) => {
  const { data } = await axiosInstance.post<ApiResponse<null>>(
    '/api/categorie/addadmin',
    credentials,
  );
  return data;
};

export const GetNoAffectedUsersGategory = async (id: number) => {
  const { data } = await axiosInstance.get<ApiResponse<AffectedUsers[]>>(
    `/api/categorie/GetNoAffectedUsers/${id}`,
  );
  return data.data;
};
